<template>
  <div>
    <b-card>
      <div class="d-flex mb-2">
        <div class="w-75">
          <b-input-group size="sm">
            <b-form-input
              :style="{ minWidth: '60%' }"
              v-model="termo_pesquisa"
              v-on:keyup.enter="loadData"
              placeholder="Pesquisar"
            ></b-form-input>
            <SelectFileCategoria
              v-model="file_categoria_id"
              placeholder="Nome"
            />
            <b-input-group-append>
              <b-button @click="loadData" variant="bagsis">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="ml-auto">
          <b-button
            size="sm"
            variant="bagsis"
            :to="{ name: 'files_create' }"
            v-if="$can('file:create') && show_btn_novo"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <div class="d-flex align-items-start">
        <b-card class="list-directories align-self-stretch">
          <b-button
            variant="primary"
            size="sm"
            class="position-absolute top-0 right-0 icon-toggle-directories"
            v-b-tooltip.hover
            :title="hintFilters"
            :class="{ 'hidden-content': !isOpenedFilters }"
            @click="toggleOpenedFilters"
          >
            <font-awesome-icon :icon="iconToggleSidebar" />
          </b-button>
          <div v-show="isOpenedFilters" class="content">
            <list-file-directories
              v-model="file_folder_id"
              @input="changeDirectory()"
            />
          </div>
        </b-card>
        <Table
          class="flex-grow-1"
          :items="files"
          :fields="fields"
          :view_edit="$can('file:edit')"
          :view_delete="$can('file:delete')"
          :view_link="true"
          :max_select="max_select"
          @delete="delete_file"
          ref="table_files"
        />
      </div>
    </b-card>

    <div>
      <pagination-nav :pagination="pagination" @input="loadData()" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixins from "@/components/Table/mixins";
import { toggleValue } from "@/mixins/toggle";
import Table from "./TableList/Table.vue";
import SelectFileCategoria from "./SelectFileCategoria.vue";
import ListFileDirectories from "@/modules/files/Components/ListFileDirectories.vue";

export default {
  mixins: [
    mixins,
    toggleValue("opened filters", {
      initialValue: true,
      falseValue: false,
      trueValue: true,
    }),
  ],

  components: {
    Table,
    SelectFileCategoria,
    ListFileDirectories,
  },
  props: {
    show_actions: {
      type: Boolean,
      default: true,
    },
    show_select: {
      type: Boolean,
      default: false,
    },
    show_btn_novo: {
      type: Boolean,
      default: true,
    },
    max_select: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    page: 1,
    termo_pesquisa: "",
    file_categoria_id: null,
    file_folder_id: null,
  }),
  computed: {
    ...mapState("files", ["files", "pagination"]),
    fields() {
      const pushItem = (condition, item) => (condition ? [item] : []);

      return [
        ...pushItem(this.show_select, { key: "select", label: "#" }),
        { key: "imagem", label: "", class: "text-center" },
        { key: "legenda", label: "Legenda" },
        { key: "categoria.nome", label: "Categoria" },
        { key: "outros", label: "#", class: "text-center" },
        ...pushItem(this.show_actions, {
          key: "actions",
          label: "",
          class: "cell-actions",
        }),
      ];

      //fields.push({ key: "oportunidades", label: "#", class: "text-center" });
    },
    iconToggleSidebar() {
      return this.isOpenedFilters
        ? "fa-solid fa-angles-left"
        : "fa-solid fa-angles-right";
    },
    hintFilters() {
      return this.isOpenedFilters ? "Ocultar diretórios" : "Exibir diretórios";
    },
  },
  methods: {
    ...mapActions("files", [
      "ActionGetAll",
      "ActionDelete",
      "ActionSetPagination",
    ]),
    async delete_file(file) {
      try {
        await this.ActionDelete(file.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao excluir registro",
          type: "danger",
        });
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    changeDirectory() {
      this.pagination.current_page = 1;
      this.loadData();
    },
    searchTerm() {
      this.pagination.current_page = 1;
      this.loadData();
      this.$router.push({
        query: {
          page: this.page,
          q: this.termo_pesquisa,
        },
      });
    },
    async loadData() {
      try {
        const payload = {
          page: this.pagination.current_page,
          per_page: this.pagination.per_page,
          q: this.termo_pesquisa,
        };

        if (this.file_categoria_id) {
          payload.file_categoria_id = this.file_categoria_id;
        }

        if (this.file_folder_id) {
          payload.file_folder_id = this.file_folder_id;
        }

        if (this.type) {
          payload.type = this.type;
        }

        await this.ActionGetAll(payload);
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    getSelected() {
      return this.$refs.table_files.getSelected();
    },
  },
  // async created() {
  //   let pagination = {
  //     current_page: 1,
  //     per_page: 15,
  //   };
  //   if (this.$route.query.page > 1) {
  //     pagination.current_page = this.$route.query.page;
  //   }
  //   console.log('pagination', pagination)
  //   /await this.ActionSetPagination(pagination);

  //   if (this.$route.query.q != "") {
  //     this.termo_pesquisa = this.$route.query.q;
  //   }
  //   this.loadData();
  // },
};
</script>
<style scoped lang="scss">
.list-directories {
  max-width: 300px;
  .card-body {
    padding-left: 0.5rem;

    &:has(.hidden-content) {
      padding: 0;
    }
  }

  .content {
    max-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  :hover {
    .icon-toggle-directories {
      transform: scale(1) !important;
    }
  }
}

.icon-toggle-directories {
  transition: all 180ms;
  transform: scale(0);
  transform-origin: center center;
  border-radius: 100vh;
  aspect-ratio: 1;
  margin-right: -15px;
  margin-top: 30px;
  z-index: 10;

  &.hidden-content {
    transform: scale(1);
  }
}
</style>
